/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Custom sorting options for video views sorting.
 */
export enum FetchVideoViewsResultSort {
    VIEWS = 'VIEWS',
    LIKES = 'LIKES',
    COMMENTS = 'COMMENTS',
    SHARES = 'SHARES',
}
